import React, { Component } from 'react';
import './Iconlist.css';
import Image from 'react-bootstrap/lib/Image';
import soundcloud_icon from '../static/icons/nysoundcloud.svg';
import facebook_icon from '../static/icons/nyfacebook.svg';
import spotify_icon from '../static/icons/nyspotify.svg';
import youtube_icon from '../static/icons/nyyoutube.svg';
import twitter_icon from '../static/icons/nytwitter.svg';
import instagram_icon from '../static/icons/nyinstagram.svg';
import custom_icon from '../static/icons/nycustom.svg';

class IconLink extends Component {
  constructor(props) {
    super(props);
    this.state = {icon: null};
  }
  findIcon(media){
    if (media === "SoundCloud") {
      return soundcloud_icon
    } else if (media === "Facebook") {
      return facebook_icon
    } else if (media === "Spotify") {
      return spotify_icon
    } else if (media === "Youtube") {
      return youtube_icon
    } else if (media === "Twitter") {
      return twitter_icon
    } else if (media === "Instagram") {
      return instagram_icon
    } else {
      return custom_icon
    }
  }
  componentDidMount(){
    this.setState( { icon:this.findIcon(this.props.media) });
  }
  render() {
    return (
      <a target="_blank" href={this.props.link}>
        <Image className="icon" alt={this.props.media} src={this.state.icon} />
      </a>
    )
  }
}

class IconLinkList extends Component {
  constructor(props) {
    super(props);
    this.state = {links: []};
    this.update = this.update.bind(this)
  }
  update(){
    const lnks = this.props.links.map(obj =>
      <IconLink link={obj.link} media={obj.media} key={obj.id}/>
    )
    this.setState( { links:lnks });
  }
  componentDidUpdate(prevProps){
    if (this.props !== prevProps) {
    this.update()
  }
  }
  componentDidMount(){
    this.update()
  }
  render() {
    return (
      <div className="alllinks">
        {this.state.links}
      </div>
    )
  }
}

export default IconLinkList;



// WEBPACK FOOTER //
// ./src/artist/Iconlist.js